// extracted by mini-css-extract-plugin
export default {"mainDiv":"Hero_mainDiv__XV+BT","colouredDiv":"Hero_colouredDiv__wtDjl","dogImage":"Hero_dogImage__c3VBR"};